module.exports = __webpack_public_path__ + "img/hot-flashes.1137fd1e.svg";